import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TimyaLogoWh from "../../assets/timya-logo-wh.png";
import data from "../services";
import ContractModal from "./ContractModal";
import "./Footer.css";

const Footer = () => {
  const navigate = useNavigate();
  const [isContractModalOpen, setIsContractModalOpen] = useState(false);

  const openContractModal = () => {
    setIsContractModalOpen(true);
  };

  const closeContractModal = () => {
    setIsContractModalOpen(false);
  };

  const openContractModalSustainability = () => {
    navigate("/surdurulebilirlik"); 
 };

  return (
    <div>
      <footer className="footer-container">
        <div className="footer-row">
          <div className="left-row">
            {/* <h1 className="hotel-name">TİMYA</h1>
            <h3 className="hotel">Otel</h3> */}
            <img src={TimyaLogoWh} className="timya-image-wh" alt="" />
          </div>
          <div className="text-row">
            <p className="text">{data.contact.address}</p>
            <p className="text">Telefon: {data.contact.telephone}</p>
            <p className="text">E-posta: {data.contact.email}</p>
          </div>
          <div className="contract-link-container">
            <p 
              className="contract-link" 
              onClick={openContractModalSustainability}
            >
              Sürdürülebilirlik
            </p>
            <p 
              className="contract-link" 
              onClick={openContractModal}
            >
              Genel Satış ve Hizmet Sözleşmesi
            </p>
    
          </div>
        </div>
        <div className="since-row">
          <p>&copy; 2024 Timya Otel resmi sayfasıdır.</p>
        </div>
      </footer>

      
      <ContractModal 
        isOpen={isContractModalOpen} 
        onClose={closeContractModal} 
      />
    </div>
  );
};

export default Footer;
